module.exports = __webpack_public_path__ + "media/assets/img/company/logo vinci-824dce73d7960a7bb9beaf5db136b53a.png";